import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const referralListEndpoint = ApiEndpoints.referral.referralList;

const tableHeader = ["Date", "Name", "email", "first name", "last name", "email", "phone", "IP Address", ];
const tbody = ["createdAt", "name", "email", "referral_first_name", "referral_last_name", "referral_email", "referral_phone", "ip_address",];

export default function Referral() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
        try {
            const response = await ApiRequest("GET", referralListEndpoint);
            const result = response.referrals;
            setData(result);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        dataFetch();
    }, []);

    const pagename = {
      name: 'PMS Referral',
      user: 'Admin',
      innerpage: 'PMS Referral'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
